import { render } from "./HelloWorld.vue?vue&type=template&id=fb40b52a&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=fb40b52a&scoped=true&lang=less"

import exportComponent from "/Users/dinghuaiqiang/gitee/lavenir-reed-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb40b52a"]])

export default __exports__